// extracted by mini-css-extract-plugin
export default {"wrapper":"filter_wrapper__ydlm0","active":"filter_active__rFSvc","closeIcon":"filter_closeIcon__Xp6SC","label":"filter_label__+zKSJ"};